import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DateAdapter } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { DatePipe } from '@angular/common';
import { ConfirmationPopupComponent } from '../confirmation-popup/confirmation-popup.component';
import { ToastrService } from 'ngx-toastr';
import { saveAs } from 'file-saver';
import { Router } from '@angular/router';
import { AddThreeSixtyReviewPopupComponent } from '../add-three-sixty-review-popup/add-three-sixty-review-popup.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { retry } from 'rxjs';
import { ExceptionCode } from '@capacitor/core';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}
@Component({
  selector: 'app-three-sixty-degree-popups',
  templateUrl: './three-sixty-degree-popups.component.html',
  styleUrls: ['./three-sixty-degree-popups.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Use en-GB to get DD/MM/YYYY format
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class ThreeSixtyDegreePopupsComponent implements OnInit {
  buttonColorName: any
  PopupName: any
  employeeTablePageCount: any = 25;
  CreateEmailDescription: any = `
  Dear Employee name, 
  <br /> <br />
  I hope this message finds you well. 
  <br /><br />
  I wanted to take a moment to extend my warmest wishes to you on [specific occasion or reason, e.g., your work anniversary, your recent promotion, your birthday]. It’s a pleasure to work with someone as dedicated and talented as you, and I wanted to let you know how much your contributions are valued. 
  <br /><br />
  [Include any additional personal note or well-wishing relevant to the occasion.] 
  <br /><br />
  Wishing you continued success and happiness. 
  <br /><br />
  Best regards, 
  <br /><br />
  [Your Full Name] 
  <br />[Your Designation]`;

  submissionEmail: any = `
  Dear Employee name, 
  <br /> <br />
  I hope this message finds you well. 
  <br /><br />
  I wanted to take a moment to extend my warmest wishes to you on [specific occasion or reason, e.g., your work anniversary, your recent promotion, your birthday]. It’s a pleasure to work with someone as dedicated and talented as you, and I wanted to let you know how much your contributions are valued. 
  <br /><br />
  [Include any additional personal note or well-wishing relevant to the occasion.] 
  <br /><br />
  Wishing you continued success and happiness. 
  <br /><br />
  Best regards, 
  <br /><br />
  [Your Full Name] 
  <br />[Your Designation]`;
  createSurveyForm: FormGroup = new FormGroup({});

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '400px',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter Email here...',
    defaultParagraphSeparator: '',
  }
  minDate = new Date();
  selectedYear: any;
  loggedInUserCompanyID: any;

  tableData = [
    {
      function: 'A',
      band: 'A',
      rows: [
        {
          competency: 'Problem Solving',
          questions: [''],
          type: '',
          hasMinus: false,
        },
        {
          competency: 'Excel',
          questions: [''],
          type: '',
          hasMinus: false,
        },
        {
          competency: 'Communication',
          questions: [''],
          type: '',
          hasMinus: false,
        },
      ],
    },
    {
      function: 'IT',
      band: 'B',
      rows: [
        {
          competency: 'Problem Solving',
          questions: [''],
          type: '',
          hasMinus: false,
        },
        {
          competency: 'Excel',
          questions: [''],
          type: '',
          hasMinus: false,
        },
        {
          competency: 'Communication',
          questions: [''],
          type: '',
          hasMinus: false,
        },
      ],
    },
  ];
  selectedEmployees: any = [];
  stakeholderIdentificationArray: any = [];
  dropdownSettings: IDropdownSettings = {};
  stakeHoldersArrayForSetup: any = [];
  subordinateWeightage: any = null;
  superiorWeightage: any = null;
  selfWeightage: any = null;
  peerWeightage: any = null;
  externalCustomerWeightage: any = null;
  internalCustomerWeightage: any = null;
  selectedReviewID: any;
  getCompetencyList: any = []
  isExternalCustomerEnabled: boolean = false;
  isPublished: boolean = false;
  isOpenEnded: boolean = true;
  isRatingBased: boolean = true;

  searchString: any;

  debounceTimer: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<ThreeSixtyDegreePopupsComponent>,
    private loader: LoaderService, private encryptionService: EncryptionService,
    private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, private datePipe: DatePipe, public dialog: MatDialog,
    public toastr: ToastrService) { }

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    console.log(this.data?.stakeHoldersArrayForSetup);

    this.PopupName = this.data.popupName;
    this.selectedYear = this.data?.selectedYear;
    this.selectedEmployees = this.data?.selectedEmployees;
    this.stakeHoldersArrayForSetup = this.data?.stakeHoldersArrayForSetup?.filter(
      (value: { name: any; }, index: any, self: any[]) =>
        index === self.findIndex((t) => t.name === value.name)
    );

    this.selectedReviewID = this.data?.selectedReviewID;
    this.stakeholdersArray = this.data?.stakeholdersArray;
    // this.subordinateWeightage = this.data?.subordinateWeightage;
    // this.superiorWeightage = this.data?.superiorWeightage;
    // this.selfWeightage = this.data?.selfWeightage;    
    // this.peerWeightage = this.data?.peerWeightage;
    // this.externalCustomerWeightage = this.data?.externalCustomerWeightage;
    // this.internalCustomerWeightage = this.data?.internalCustomerWeightage;
    this.selfWeightage = this.stakeHoldersArrayForSetup.find(
      (s: { selected: boolean; name: string }) => s.name === 'Self' && s.selected
    )?.weightage;

    this.superiorWeightage = this.stakeHoldersArrayForSetup.find(
      (s: { selected: boolean; name: string }) => s.name === 'Superior' && s.selected
    )?.weightage;

    this.peerWeightage = this.stakeHoldersArrayForSetup.find(
      (s: { selected: boolean; name: string }) => s.name === 'Peer' && s.selected
    )?.weightage;

    this.subordinateWeightage = this.stakeHoldersArrayForSetup.find(
      (s: { selected: boolean; name: string }) => s.name === 'Subordinate' && s.selected
    )?.weightage;

    this.internalCustomerWeightage = this.stakeHoldersArrayForSetup.find(
      (s: { selected: boolean; name: string }) => s.name === 'Internal Customer' && s.selected
    )?.weightage;

    this.externalCustomerWeightage = this.stakeHoldersArrayForSetup.find(
      (s: { selected: boolean; name: string }) => s.name === 'External Customer' && s.selected
    )?.weightage;

    // this.getCompetencyList = this.data?.getCompetencyList; 
    //  create a  local copy of getCompetencyList
    this.getCompetencyList = this.data?.getCompetencyList
      ? this.data.getCompetencyList.map((item: any) => ({
        ...item,
        competencies: item.competencies.map((c: any) => ({
          ...c,
          questions: c.questions.map((q: any) => ({ ...q }))
        }))
      }))
      : [];

    //  keep original backup for search reset
    this.originalCompetencyList = this.getCompetencyList;

    this.isOpenEnded = this.data.isOpenEnded,
      this.isRatingBased = this.data.isRatingBased,
      this.isExternalCustomerEnabled = this.data?.isExternalCustomerEnabled;
    this.isPublished = this.data?.isPublished;
    this.initilaizeAddSurveyForm();
    this.getAllEmployeeDropdownByCompanyID();
    if (this.PopupName == 'Create Question') {
      if (this.getCompetencyList.length == 0) {
        this.getCompetencyFor360()
      } else {
        this.getCompetencyFor360()
      }
    }
    console.warn('isOpenEnded', this.data.isOpenEnded);
    console.warn('isRatingBased', this.data.isRatingBased);
  }
  initilaizeAddSurveyForm() {
    this.createSurveyForm = this.fb.group({
      review360Name: [null, Validators.required],
      startDate: [null, Validators.required],
      endDate: [null, Validators.required],
    })
  }
  closeDialog() {
    this.dialogRef.close();
  }
  createSurvey() {

    const test = this.selectedYear?.split('-');
    if (this.createSurveyForm.valid) {
      this.closeDialog();
      const request = {
        "band": [],
        "companyId": this.loggedInUserCompanyID,
        "competencies": [],
        "department": [],
        "employee": [],
        "endDate": this.datePipe.transform(this.createSurveyForm.value.endDate, "yyyy-MM-dd"),
        "externalCustomerWeightage": null,
        "fromYear": test[0],
        "grade": [],
        "id": null,
        "instruction": [],
        "internalCustomerWeightage": null,
        "invitationEmailBody": null,
        "invitationEmailSubject": null,
        "isExternalCustomerEnabled": false,
        "isReminderOn": false,
        "isReportsVisibleToHr": false,
        "location": [],
        "peerWeightage": null,
        "ratings": [],
        "reminderDate": [],
        "review360Name": this.createSurveyForm.value.review360Name,
        "review360Status": "Pending",
        "reviewCutoff": null,
        "selfWeightage": null,
        "stakeholders": [],
        "startDate": this.datePipe.transform(this.createSurveyForm.value.startDate, "yyyy-MM-dd"),
        "submissionEmailBody": null,
        "submissionEmailSubject": null,
        "subordinateWeightage": null,
        "superiorWeightage": null,
        "templateName": null,
        "toYear": test[1]
      }
      this.loader.simpleLoader();
      this.httpService.callPostService(this.config.save360, request).
        subscribe((data: any) => {
          this.loader.dismissLoader()
          if (data?.status) {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: data.message,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            });
            successdialogRef.afterClosed().subscribe(result => {
              this.closeDialog();
              this.loader.dismissLoader()
            });
          } else {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: data.message,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: false,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            });
            successdialogRef.afterClosed().subscribe(result => {
              this.closeDialog();
            });
          }
        })
    }
  }


  addCommunicationRow(i: number, k: number): void {
    this.getCompetencyList[i].competencies.push(
      {
        competencyName: 'Other',
        questions: [{ question: '', questionType: 'Rating Based', id: null }]
      })
  }

  removeCommunicationRow(i: number, k: number): void {
    this.getCompetencyList[i].competencies.splice(-1, 1)
  }

  addQuestionRow(i: number, k: number): void {
    this.getCompetencyList[i].competencies[k].questions.push({ question: '', questionType: 'Rating Based', id: null })
  }

  removeQuestionRow(i: number, k: number, j: number): void {
    this.getCompetencyList[i].competencies[k].questions.splice(j, 1)
  }

  // AddBtn() {
  //   const successdialogRef = this.dialog.open(AddThreeSixtyReviewPopupComponent, {
  //     disableClose: true,
  //     height: '30%',
  //     width: '70%',
  //     data: {
  //       popupName: 'addPopup',
  //       selectedReviewID: this.selectedReviewID,
  //       reviewUserId: reviewUserId
  //     },
  //   });
  //   successdialogRef.afterClosed().subscribe(result => {
  //     if (result) {
  //      this.externalCustomerEmployeeIds = result.externalUser
  //     }
  //   });
  // }
  editExtUser(data: any, poupname: any) {

    const successdialogRef = this.dialog.open(AddThreeSixtyReviewPopupComponent, {
      disableClose: true,
      height: '30%',
      width: '70%',
      data: {
        popupName: poupname,
        selectedReviewID: this.selectedReviewID,
        data: data?.externaluserList,
        reviewUserId: data?.reviewUserId
      },
    });
    successdialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.stakeholderIdentificationArray?.forEach((ele: any) => {
          if (ele.reviewUserId == result?.reviewUserId) {
            ele.externaluserList = result.externalUser;
          }
        })
      }
    });
  }
  createArray() {
    this.stakeholderIdentificationArray = [];
    this.selectedEmployees?.forEach((ele: any) => {
      let obj = {
        reviewUserName: ele.firstName + ' ' + ele.lastName,
        reviewUserId: ele.id,
        stakeHolderSelfId: ele.id,
        stakeHolderSelfUserName: ele.firstName + ' ' + ele.lastName,
        superiorUserList: this.getAllEmployeeofCompany,
        subordinatesUserList: this.getAllEmployeeofCompany,
        peersUserList: this.getAllEmployeeofCompany,
        internalCutomerUserList: this.getAllEmployeeofCompany,
        selectedSuperiorUserList: this.getAllEmployeeofCompany,
        selectedSubordinatesUserList: this.getAllEmployeeofCompany,
        selectedPeersUserList: this.getAllEmployeeofCompany,
        selectedInternalCutomerUserList: this.getAllEmployeeofCompany,
        externaluserList: []
      }
      this.stakeholderIdentificationArray.push(obj)
    })
    if (this.stakeholdersArray?.length != 0) {
      // this.stakeholderIdentificationArray?.forEach((ele: any) => {
      //   this.stakeholdersArray?.forEach((ele1: any) => {
      //     if (ele.reviewUserId == ele1.userId) {

      //       ele.externaluserList = ele1.externalCustomerEmployeeIds;
      //       ele.selectedSuperiorUserList = ele1.superiorEmployeeIds.map((id: any) => this.getAllEmployeeofCompany.find((emp: any) => emp.id === id));
      //       ele.selectedSubordinatesUserList = ele1.subordinateEmployeeIds.map((id: any) => this.getAllEmployeeofCompany.find((emp: any) => emp.id === id));
      //       ele.selectedPeersUserList = ele1.peerEmployeeIds.map((id: any) => this.getAllEmployeeofCompany.find((emp: any) => emp.id === id));
      //       ele.selectedInternalCutomerUserList = ele1.internalCustomerEmployeeIds.map((id: any) => this.getAllEmployeeofCompany.find((emp: any) => emp.id === id));
      //     }
      //   })
      // })

      this.stakeholderIdentificationArray?.forEach((ele: any) => {
        this.stakeholdersArray?.forEach((ele1: any) => {
          if (ele.reviewUserId == ele1.userId) {
            ele.externaluserList = ele1.externalCustomerEmployeeIds;

            ele.selectedSuperiorUserList = ele1.superiorEmployeeIds
              ?.map((id: any) => this.getAllEmployeeofCompany.find((emp: any) => emp.id === id) || null)
              .filter((emp: any) => emp !== null); // Remove undefined/null

            ele.selectedSubordinatesUserList = ele1.subordinateEmployeeIds
              ?.map((id: any) => this.getAllEmployeeofCompany.find((emp: any) => emp.id === id) || null)
              .filter((emp: any) => emp !== null);

            ele.selectedPeersUserList = ele1.peerEmployeeIds
              ?.map((id: any) => this.getAllEmployeeofCompany.find((emp: any) => emp.id === id) || null)
              .filter((emp: any) => emp !== null);

            ele.selectedInternalCutomerUserList = ele1.internalCustomerEmployeeIds
              ?.map((id: any) => this.getAllEmployeeofCompany.find((emp: any) => emp.id === id) || null)
              .filter((emp: any) => emp !== null);
          }
        });
      });

    }
  }
  getAllEmployeeofCompany: any = [];
  externalCustomerEmployeeIds: any = [];
  getAllEmployeeDropdownByCompanyID() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "search": this.searchString || null
    }
    this.httpService.callPostService(this.config.getAllEmployeeDropdownByCompanyID, request)
      .subscribe((data: any) => {
        this.getAllEmployeeofCompany = [];
        data?.data?.users.forEach((ele: any) => {
          let obj = {
            id: ele.id,
            name: ele.firstName + ' ' + ele.lastName,
          }
          this.getAllEmployeeofCompany.push(obj);
        });
        this.createArray();
      }, (error: any) => {
      }, () => { });
  }
  stakeholdersArray: any = [];
  onClickSaveStakeholderIdentification(operation: any) {
    // 1️⃣ Sync individual weightages from the current stakeholder array
    this.selfWeightage = this.stakeHoldersArrayForSetup.find(
      (s: { selected: boolean; name: string }) => s.name === 'Self' && s.selected
    )?.weightage;

    this.superiorWeightage = this.stakeHoldersArrayForSetup.find(
      (s: { selected: boolean; name: string }) => s.name === 'Superior' && s.selected
    )?.weightage;

    this.peerWeightage = this.stakeHoldersArrayForSetup.find(
      (s: { selected: boolean; name: string }) => s.name === 'Peer' && s.selected
    )?.weightage;

    this.subordinateWeightage = this.stakeHoldersArrayForSetup.find(
      (s: { selected: boolean; name: string }) => s.name === 'Subordinate' && s.selected
    )?.weightage;

    this.internalCustomerWeightage = this.stakeHoldersArrayForSetup.find(
      (s: { selected: boolean; name: string }) => s.name === 'Internal Customer' && s.selected
    )?.weightage;

    this.externalCustomerWeightage = this.stakeHoldersArrayForSetup.find(
      (s: { selected: boolean; name: string }) => s.name === 'External Customer' && s.selected
    )?.weightage;


    // 2️⃣ Handle save operation
    if (operation === 'save') {
      console.log(this.stakeHoldersArrayForSetup);

      // Sum weightage of selected stakeholders
      let totalWeightage = this.stakeHoldersArrayForSetup
        .filter((s: { selected: any; }) => s.selected)
        .reduce((sum: any, s: { weightage: any; }) => sum + (s.weightage), 0);

      // // Add external customer if enabled
      // if (this.isExternalCustomerEnabled) {
      //   totalWeightage += this.externalCustomerWeightage;
      // }

      // Check if total is 100
      if (totalWeightage !== 100) {
        this.toastr.error('Total Weightage should be 100.', '', { timeOut: 3000 });
        return;
      }
    }

    // 3️⃣ Handle close operation
    if (operation === 'close') {
      if (
        this.data?.selfWeightage == null &&
        this.data?.superiorWeightage == null &&
        this.data?.subordinateWeightage == null &&
        this.data?.peerWeightage == null &&
        this.data?.internalCustomerWeightage == null &&
        this.data?.externalCustomerWeightage == null
      ) {
        this.selfWeightage = null;
        this.superiorWeightage = null;
        this.subordinateWeightage = null;
        this.peerWeightage = null;
        this.internalCustomerWeightage = null;
        this.externalCustomerWeightage = null;
      }
    }

    // // 4️⃣ Prepare stakeholders array
    // this.stakeholdersArray = [];
    // this.stakeholderIdentificationArray?.forEach((ele: any) => {
    //   console.log("test elm",ele);

    //   const obj = {
    //     externalCustomerEmployeeIds: ele.externaluserList || [],
    //     id: null,
    //     internalCustomerEmployeeIds: ele?.selectedInternalCutomerUserList?.map((i: any) => i.id) || [],
    //     peerEmployeeIds: ele?.selectedPeersUserList?.map((i: any) => i.id) || [],
    //     subordinateEmployeeIds: ele?.selectedSubordinatesUserList?.map((i: any) => i.id) || [],
    //     superiorEmployeeIds: ele?.selectedSuperiorUserList?.map((i: any) => i.id) || [],
    //     userId: ele.reviewUserId
    //   };
    //   this.stakeholdersArray.push(obj);
    // });
    this.stakeholdersArray = [];

    this.stakeholderIdentificationArray?.forEach((ele: any) => {
      console.log("test elm", ele);

      const obj: any = {
        id: null,
        userId: ele.reviewUserId
      };

      // helper function
      const isSelected = (name: string) =>
        this.stakeHoldersArrayForSetup.some(
          (s: any) => s.name === name && s.selected
        );

      // Superior
      obj.superiorEmployeeIds = isSelected('Superior')
        ? ele?.selectedSuperiorUserList?.map((i: any) => i.id) || []
        : [];

      // Subordinate
      obj.subordinateEmployeeIds = isSelected('Subordinate')
        ? ele?.selectedSubordinatesUserList?.map((i: any) => i.id) || []
        : [];

      // Peer
      obj.peerEmployeeIds = isSelected('Peer')
        ? ele?.selectedPeersUserList?.map((i: any) => i.id) || []
        : [];

      // Internal Customer
      obj.internalCustomerEmployeeIds = isSelected('Internal Customer')
        ? ele?.selectedInternalCutomerUserList?.map((i: any) => i.id) || []
        : [];

      // External Customer
      obj.externalCustomerEmployeeIds = isSelected('External Customer')
        ? ele.externaluserList || []
        : [];

      this.stakeholdersArray.push(obj);
    });


    // 5️⃣ Prepare final data object
    const data = {
      subordinateWeightage: this.subordinateWeightage,
      superiorWeightage: this.superiorWeightage,
      selfWeightage: this.selfWeightage,
      peerWeightage: this.peerWeightage,
      externalCustomerWeightage: this.externalCustomerWeightage,
      internalCustomerWeightage: this.internalCustomerWeightage,
      stakeholdersArray: this.stakeholdersArray
    };

    console.log(data);

    // 6️⃣ Close dialog with data
    this.dialogRef.close(data);
  }


  originalCompetencyList: any[] = [];

  // getCompetencyFor360() {
  //   const test = this.selectedYear?.split('-');
  //   const request = {
  //     "companyId": this.loggedInUserCompanyID,
  //     "fromYear": test[0],
  //     "search": null,
  //     "toYear": test[1],
  //     "userIds": this.selectedEmployees.map((ele: any) => ele.id),
  //   }
  //   this.httpService.callPostService(this.config.getCompetencyFor360, request)
  //     .subscribe((data: any) => {
  //       console.log("create questions....",data);

  //       this.getCompetencyList = []
  //       data?.data?.forEach((ele: any) => {
  //         let obj = {
  //           band: ele.band,
  //           department: ele.functionName,
  //           competencies: ele.competencyMasterlist?.map((ele1: any) => ({
  //             competencyName: ele1.competencyName,
  //             questions: [{ question: '', questionType: '', id: null }]
  //           })) || [],
  //         }
  //         this.getCompetencyList.push(obj)
  //         console.log("list 11111111......",this.getCompetencyList);

  //       })
  //     }, (error: any) => {
  //     }, () => { });
  // }
  searchText: string = '';

  // onSearch(event:any) {
  //   const search = this.searchText.trim().toLowerCase();
  //  console.log("  List 22222.... ",    this.getCompetencyList );
  //    this.getCompetencyList 
  //     .map((item: { competencies: any[]; }) => ({
  //       ...item,
  //       competencies: item.competencies.filter((c: any) =>
  //         c.competencyName?.toLowerCase().includes(search) ||
  //         c.department?.toLowerCase().includes(search) ||
  //         c.band?.toLowerCase().includes(search) ||
  //         c.questions?.some((q: any) => q.question.toLowerCase().includes(search))
  //       )
  //     }))
  //     .filter((item: { competencies: string | any[]; }) => item.competencies.length > 0);
  // }

  // getCompetencyFor360() {
  //   const test = this.selectedYear?.split('-');
  //   const request = {
  //     companyId: this.loggedInUserCompanyID,
  //     fromYear: test[0],
  //     toYear: test[1],
  //     search: null,
  //     userIds: this.selectedEmployees.map((ele: any) => ele.id),
  //   };
  //   console.log("Selected users @@....", this.selectedEmployees);

  //   this.httpService.callPostService(this.config.getCompetencyFor360, request)
  //     .subscribe((data: any) => {
  //       console.log("Original competency list...", data);

  //       this.getCompetencyList = data?.data?.map((ele: any) => ({
  //         band: ele.band,
  //         department: ele.functionName,
  //         competencies: ele.competencyMasterlist?.map((ele1: any) => ({
  //           competencyName: ele1.competencyName,
  //           questions: [{ question: '', questionType: '', id: null }]
  //         })) || [],
  //       })) || [];
  //       console.log("Competnecy 111....", this.getCompetencyList);

  //       // keep reference for search reset
  //       this.originalCompetencyList = this.getCompetencyList;
  //       console.log("comptenyc 222....", this.originalCompetencyList);

  //     });
  // }
getCompetencyFor360() {
  const test = this.selectedYear?.split('-');
  const request = {
    companyId: this.loggedInUserCompanyID,
    fromYear: test[0],
    toYear: test[1],
    search: null,
    userIds: this.selectedEmployees.map((ele: any) => ele.id),
  };

  this.httpService.callPostService(this.config.getCompetencyFor360, request)
    .subscribe((res: any) => {
      const apiData = res?.data || [];

      apiData.forEach((apiBand: any) => {
        // 🔹 Find existing band + department
        let existingBand = this.getCompetencyList.find(
          (b: any) => b.band === apiBand.band && b.department === apiBand.functionName
        );

        if (!existingBand) {
          // 🆕 New Band → Add directly
          this.getCompetencyList.push({
            band: apiBand.band,
            department: apiBand.functionName,
            competencies: apiBand.competencyMasterlist?.map((c: any) => ({
              competencyName: c.competencyName,
              competencyDefination: c.competencyDefination,
              questions: [{ question: '', questionType: '', id: null }],
              rating: null,
            })) || [],
          });
        } else {
          // 🔹 Merge competencies by competencyName
          apiBand.competencyMasterlist.forEach((newComp: any) => {
            const existingComp = existingBand.competencies.find(
              (c: any) => c.competencyName === newComp.competencyName
            );

            if (existingComp) {
              // ✅ Update definition if changed, keep questions/rating
              existingComp.competencyDefination = newComp.competencyDefination;
            } else {
              // 🆕 Add new competency
              existingBand.competencies.push({
                competencyName: newComp.competencyName,
                competencyDefination: newComp.competencyDefination,
                questions: [{ question: '', questionType: '', id: null }],
                rating: null,
              });
            }
          });
        }
      });

      // ✅ Remove old bands not present in API (optional but recommended)
      this.getCompetencyList = this.getCompetencyList.filter((band: any) =>
        apiData.some(
          (apiBand: any) =>
            apiBand.band === band.band && apiBand.functionName === band.department
        )
      );

      // ✅ Deep clone backup
      this.originalCompetencyList = JSON.parse(JSON.stringify(this.getCompetencyList));

      console.log('✅ Final merged competency list:', this.getCompetencyList);
    });
}



  onSearch(event: any) {
    const search = event.target.value.trim().toLowerCase();

    if (!search) {
      // reset to original
      this.getCompetencyList = this.originalCompetencyList;
      return;
    }

    this.getCompetencyList = this.originalCompetencyList
      .map(item => ({
        ...item,
        competencies: item.competencies.filter((c: { competencyName: string; questions: any[]; }) =>
          c.competencyName?.toLowerCase().includes(search) ||
          item.department?.toLowerCase().includes(search) ||
          item.band?.toLowerCase().includes(search) ||
          c.questions?.some((q: any) => q.question?.toLowerCase().includes(search))
        )
      }))
      .filter(item => item.competencies.length > 0);
  }



  toastShown = false;

  checkMaxLength(comment: string) {
    if (comment?.length === 255 && !this.toastShown) {
      this.toastShown = true;

      this.toastr.error('Maximum limit is 255 characters', 'Limit Reached');

      setTimeout(() => {
        this.toastShown = false;
      }, 3000);
    }
  }


  onClickSaveQuestion(operation: any) {
    console.log("competency list.....", this.getCompetencyList);

    if (operation == 'save') {
      if (this.getCompetencyList.some((item: any) =>
        item.competencies.some((competency: any) =>
          competency.questions.some((q: any) => q.question === '')
        )
      )) {
        this.toastr.error('Please fill all mandetory fields.', '', {
          timeOut: 3000,
        });
        return;
      }

    }
    this.originalCompetencyList = this.getCompetencyList;

    let data = {
      getCompetencyList: this.getCompetencyList
    }
    this.dialogRef.close(data);
  }

  getReview360ById() {
    const request = {
      "id": this.selectedReviewID,
      "search": this.searchString || null
    }
    this.httpService.callPostService(this.config.getReview360ById, request).subscribe((data: any) => {

      this.selectedEmployees = [];
      data?.data?.employee?.forEach((ele: any) => {
        let obj = {
          id: ele
        }
        this.selectedEmployees.push(obj);
        this.createArray();
      })
    })
  }

  onSearchStakeholderIdentification(event: any) {
    this.searchString = event.target.value.trim();
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      if (!this.searchString) {
        this.createArray();
      } else {
        const lowerSearch = this.searchString.toLowerCase();
        const filteredStakeholderIdentificationArray = this.stakeholderIdentificationArray.filter((ele: any) =>
          ele.reviewUserName.toLowerCase().includes(lowerSearch)
        );
        this.stakeholderIdentificationArray = filteredStakeholderIdentificationArray
      }
    }, 300);
  }



}
